<avano-panel *ngIf="isShow" class="article-details-panel" [headerText]="product?.productType | declarationNodeEditorHeaderText | translate">
  <scip-product-form *ngIf="product" [product]="product" [disabled]="disableFormFields" (formChange)="productChanged($event)"></scip-product-form>
  <scip-substance-form *ngIf="substance" [substance]="substance"></scip-substance-form>
</avano-panel>
